import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const initialForUiState = {
  value: {
    "Business Details": {
      "Phone number": true,
      Address: true,
      Email: true,
      Name: true,
      Website: true,
      About: true,
      CAGE: true,
      DUNS: true,
      "Entity type": true,
      Revenue: true,
    },
    codesAndCertification: true,
    mbeCertificate: true,
    companyCodes: true,
    "core competencies": true,
    "client list": true,
    differentiators: true,
    showTemplate: false,
  },
};
export const formUiSlice = createSlice({
  name: "formUI",
  initialState: initialForUiState,
  reducers: {
    updateFormUi: (
      state,
      action: PayloadAction<typeof initialForUiState["value"]>
    ) => {
      console.log(action.payload);
      state.value = { ...action.payload };
    },
    resetFormui: (state, action) => {
      state.value = initialForUiState.value;
    },
  },
});

export type uiStateType = typeof initialForUiState["value"];
export const { updateFormUi, resetFormui } = formUiSlice.actions;
export default formUiSlice.reducer;
